'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import GenericContentOptions from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/contentOptions/GenericContentOptions';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class FollowupEmailContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      error: null
    };

    this.setError = error => {
      this.setState({
        error
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    const {
      error
    } = this.state;
    return /*#__PURE__*/_jsx(GenericContentOptions, Object.assign({}, this.props, {
      inputProps: {
        setError: this.setError,
        error: !!error,
        readOnly
      },
      formControlProps: {
        validationMessage: error,
        label: I18n.text(i18nKey(`defaultLabels.${field.type}`))
      }
    }));
  }

}
FollowupEmailContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};